export default __webpack_public_path__ + "static/B0158-d8fbe1e569ced5e11b64ace5b3ab1b0a.png";